import { Modal, Button } from 'react-bootstrap';
import { useState } from 'react';
import trueIcon from '../../assets/media/svg/trueIcon.svg';

const InformModal = (props: any) => {
  const [loading, setLoading] = useState(false);

  return (
    <Modal
      {...props}
      show={props.show}
      onHide={props.onHide}
      dialogClassName="modal-dialog-centered custom-modal-dialog-450"
      className="border-r10px"
      centered
      backdrop="static"
    >
      <Modal.Body className="text-center">
        <img
          src={trueIcon}
          alt="Img"
        />
        <h4 className="fw-500 fs-24 mt-3">
          Thank you for submitting the form!
        </h4>
        <p className="fs-14 fw-400 text-muted">
          We’ll be in touch soon to schedule a time to chat.
        </p>
        <div className="d-flex justify-content-end justify-content-center gap-4 mt-7">
          <Button
            variant="success"
            className="p-2 px-3 border-0 fw-700 fs-14"
            onClick={props.onHide}
            disabled={loading}
            style={{ backgroundColor: '#007B8B' }}
          >
            Great Thanks!
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InformModal;
